'use strict';

/**
 * Hero Banner Carousel - Slick Carousel Integration
 * Handles auto-rotation, arrow navigation (Callebaut-style), pause on hover, and animations
 * Preserves all functionality and UI from custom implementation
 */

// Import dependencies
var BannerCarouselConfig = require('../../utils/bannerCarouselConfig');

/**
 * Calculate header heights and set CSS variables on document root for margin-block-start
 */
function updateHeaderHeights() {
    var header = document.querySelector('header');
    if (!header) return;

    var headerBanner = header.querySelector('.header-banner');
    var headerMobile = header.querySelector('.header-mobile');
    var headerDesktop = header.querySelector('.header-desktop');
    var promoBar = header.querySelector('.promo-bar');

    // Calculate heights using offsetHeight
    var headerBannerHeight = headerBanner ? headerBanner.offsetHeight : 0;
    var headerMobileHeight = headerMobile ? headerMobile.offsetHeight : 0;
    var headerDesktopHeight = headerDesktop ? headerDesktop.offsetHeight : 0;
    var promoBarHeight = promoBar ? promoBar.offsetHeight : 0;

    // Total header heights (including banner if visible)
    var totalMobileHeight = headerBannerHeight + headerMobileHeight;
    var totalDesktopHeight = headerBannerHeight + headerDesktopHeight;

    // Set header height CSS variables on document root (for margin-block-start)
    document.documentElement.style.setProperty('--header-mobile-height', totalMobileHeight + 'px');
    document.documentElement.style.setProperty('--header-desktop-height', totalDesktopHeight + 'px');
    document.documentElement.style.setProperty('--promo-bar-height', promoBarHeight + 'px');
    document.documentElement.style.setProperty('--nav-mobile-height', headerMobileHeight + 'px');
    document.documentElement.style.setProperty('--nav-desktop-height', headerDesktopHeight + 'px');
}

// Call the function on page load
window.onload = updateHeaderHeights;

// Also call it when the window is resized to handle responsive changes
window.onresize = updateHeaderHeights;

$(document).ready(function () {
    /**
     * Split text into lines for animation
     * @param {jQuery} $element - Element containing text to split
     */
    function splitTextIntoLines($element) {
        var text = $element.text().trim();
        if (!text) return;

        var originalHTML = $element.html();
        var words = text.split(' ');
        var lines = [];
        var currentLine = '';

        // Get width from the text container (hero-banner-text-container)
        var $textContainer = $element.closest('.hero-banner-text-container');
        var maxWidth;
        var viewportWidth = $(window).width();

        if ($textContainer.length && $textContainer.width() > 0) {
            // Use text container width but cap it for consistent line breaking
            var containerWidth = $textContainer.width();

            // Cap width to ensure consistent 2-line breaking
            // Desktop (>768px): max 900px for headers, 800px for subheaders
            // Mobile (<=768px): use container width as-is
            var maxCap;
            if (viewportWidth > 768) {
                // Desktop: apply caps for consistency
                if ($element.hasClass('hero-banner-header')) {
                    maxCap = 900; // Headers get slightly more width
                } else {
                    maxCap = 800; // Subheaders/subtitles get less
                }
                maxWidth = Math.min(containerWidth, maxCap);
            } else {
                // Mobile: use container width as-is
                maxWidth = containerWidth;
            }
        } else {
            // Fallback to content container
            var $content = $element.closest('.hero-banner-content');
            if ($content.length && $content.width() > 0) {
                maxWidth = $content.width();
            } else {
                // Last resort fallback
                maxWidth = viewportWidth * 0.6;
            }
        }

        // Create a temporary container for measuring (off-screen)
        var $tempContainer = $('<div>').css({
            position: 'absolute',
            visibility: 'hidden',
            top: '-9999px',
            left: '-9999px',
            width: maxWidth + 'px',
            'font-size': $element.css('font-size'),
            'font-family': $element.css('font-family'),
            'font-weight': $element.css('font-weight'),
            'line-height': $element.css('line-height'),
            'letter-spacing': $element.css('letter-spacing')
        }).appendTo('body');

        var $tempSpan = $('<span style="white-space: nowrap;"></span>').appendTo($tempContainer);

        words.forEach(function (word, index) {
            var tempText = currentLine + (currentLine ? ' ' : '') + word;
            $tempSpan.text(tempText);
            var tempWidth = $tempSpan.width();

            if (tempWidth > maxWidth && currentLine !== '') {
                lines.push(currentLine);
                currentLine = word;
            } else {
                currentLine = tempText;
            }

            if (index === words.length - 1) {
                lines.push(currentLine);
            }
        });

        $tempContainer.remove();

        // Always wrap in text-line spans, even for single lines (for consistent animation)
        var linesHTML = lines.map(function (line, index) {
            return '<span class="text-line" data-line="' + index + '">' + line + '</span>';
        }).join('');

        $element.html(linesHTML);
        $element.data('original-html', originalHTML);
    }

    /**
     * Split slide text into lines for animation
     * @param {jQuery} $slide - Slide element containing text
     */
    function splitSlideText($slide) {
        // Only split header text (not subheader or subtitle)
        var $header = $slide.find('.hero-banner-header');

        if ($header.length && !$header.data('split')) {
            splitTextIntoLines($header);
            $header.data('split', true);
        }

        $slide.addClass('text-split-ready');
    }

    $('.hero-banner-carousel').each(function () {
        var $carousel = $(this);
        var $slidesContainer = $carousel.find('.carousel-slides');
        var $prevArrow = $carousel.find('.carousel-arrow-prev');
        var $nextArrow = $carousel.find('.carousel-arrow-next');

        var autoRotate = $carousel.data('auto-rotate') === true || $carousel.data('auto-rotate') === 'true';
        var rotateInterval = parseInt($carousel.data('rotate-interval'), 10) * 1000 || 5000;
        var pauseOnHover = $carousel.data('pause-on-hover') === true || $carousel.data('pause-on-hover') === 'true';

        var totalSlides = $slidesContainer.find('.carousel-slide').length;

        if (totalSlides <= 1) {
            return;
        }

        // Split text for all slides upfront (faster batch processing)
        $slidesContainer.find('.carousel-slide').each(function () {
            splitSlideText($(this));
        });

        // Initialize Slick carousel with config from utility
        var slickConfig = BannerCarouselConfig.getHeroBannerConfig({
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            autoRotate: autoRotate,
            rotateInterval: rotateInterval,
            pauseOnHover: pauseOnHover,
            beforeChange: function (_event, _slick, _currentSlide, _nextSlide) {
                $slidesContainer.find('.carousel-slide').removeClass('animate-content');
            },
            afterChange: function (_event, _slick, _currentSlide) {
                // Use utility function with faster delay for snappier animation
                BannerCarouselConfig.triggerSlideAnimation($slidesContainer, 'carousel-slide', 20);
            }
        });

        $slidesContainer.slick(slickConfig);

        // Trigger first slide animation immediately using utility
        BannerCarouselConfig.initFirstSlideAnimation($slidesContainer, 'carousel-slide');

        // Setup arrow handlers with animation using utility
        BannerCarouselConfig.setupArrowHandlers($prevArrow, $nextArrow, $slidesContainer, 'carousel-slide');

        // Setup swipe animation handler using utility
        BannerCarouselConfig.setupSwipeHandler($slidesContainer, 'carousel-slide');

        // Setup auto-rotate detection using utility
        if (autoRotate) {
            BannerCarouselConfig.setupAutoRotateDetection($slidesContainer, $prevArrow, $nextArrow, 'carousel-slide');
        }

        // Setup visibility handler for pausing using utility
        if (autoRotate) {
            BannerCarouselConfig.setupVisibilityHandler($slidesContainer);
        }

        // Setup keyboard navigation using utility
        BannerCarouselConfig.setupKeyboardNavigation($carousel, $slidesContainer);

        // Note: Resize handler removed - users rarely resize browser during browsing
        // Text splitting happens once on page load, which covers 99.9% of use cases
        // Device rotation would typically reload the page anyway
    });

    // Apply line splitting to single image banners as well
    $('.hero-banner-container').each(function () {
        var $container = $(this);

        // Split text into lines
        splitSlideText($container);

        // Trigger animation after split (small delay to ensure split is complete)
        setTimeout(function () {
            $container.addClass('animate-content');
        }, 50);

        // Note: Resize handler removed - users rarely resize browser during browsing
        // Text splitting happens once on page load, which covers 99.9% of use cases
        // Device rotation would typically reload the page anyway
    });
});
